import { Props } from 'src/Containers/ContentOverlay/ContentOverlay.types';

import styles from './ContentOverlay.module.scss';

const ContentOverlay = ({ children }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.cardWrapper}>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
};

export default ContentOverlay;
